export const UrlSearchParams = {
  search: 'search',
  roles: 'roles',
  eventId: 'eventId',
  fileAndDocumentType: 'fileAndDocumentType',
}
